import React from "react";
import { useParams } from "react-router-dom";

import blogTopics from "../data/blogTopics";
import BlogArticle from "../components/blog/BlogArticle";
import CTASection from "../components/sections/CTASection";

function BlogDetailPage() {
  const { slug } = useParams();

  const article = blogTopics.find((item) => item.slug === slug);

  if (!article) {
    return (
      <div
        style={{
          padding: "150px 20px",
          textAlign: "center",
        }}
      >
        <h1>Article Not Found</h1>
      </div>
    );
  }

  return (
    <>
      <section
        style={{
          background: "linear-gradient(135deg,#002147,#003d5c)",
          color: "#ffffff",
          padding: "140px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "14px",
              marginBottom: "22px",
              alignItems: "center",
            }}
          >
            <span
              style={{
                color: "#21b573",
                fontWeight: 700,
                letterSpacing: ".08em",
                textTransform: "uppercase",
              }}
            >
              {article.category}
            </span>

            {article.trendBadge && (
              <span
                style={{
                  padding: "8px 14px",
                  borderRadius: "999px",
                  background: "rgba(255,255,255,0.12)",
                  color: "#fff",
                  fontSize: ".85rem",
                }}
              >
                {article.trendBadge}
              </span>
            )}
          </div>

          <h1
            style={{
              fontSize: "clamp(3rem,5vw,5rem)",
              fontFamily: "Playfair Display, serif",
              marginBottom: "24px",
              lineHeight: 1.05,
            }}
          >
            {article.title}
          </h1>

          <p
            style={{
              color: "#e2e8f0",
              maxWidth: "850px",
              lineHeight: 1.9,
              fontSize: "1.1rem",
              marginBottom: "28px",
            }}
          >
            {article.excerpt}
          </p>

          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
              color: "#e2e8f0",
              fontSize: ".96rem",
            }}
          >
            <span>{article.author}</span>
            <span>•</span>
            <span>{article.authorRole}</span>
            <span>•</span>
            <span>{article.publishDate}</span>
            <span>•</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </section>

      <section
        style={{
          padding: "100px 20px",
          background: "#ffffff",
        }}
      >
        <BlogArticle article={article} />
      </section>

      <CTASection />
    </>
  );
}

export default BlogDetailPage;
